import { Reveal } from "./Reveal";

export const groupBy = (items, key) =>
  items.reduce((acc, it) => {
    (acc[it[key]] = acc[it[key]] || []).push(it);
    return acc;
  }, {});

export const PriceRow = ({ s }) => (
  <li className="flex items-end py-2.5 text-sm md:text-[0.95rem]" data-testid={`price-row-${s.id}`}>
    <span>{s.name}</span>
    <span className="dotted-leader" />
    <span className={s.price ? "font-medium whitespace-nowrap" : "italic text-[#8C6E48] whitespace-nowrap text-xs md:text-sm"}>
      {s.price || "Pris etter vurdering"}
    </span>
  </li>
);

export const PriceList = ({ services, limitCategories }) => {
  const groups = groupBy(services, "category");
  const cats = Object.keys(groups).slice(0, limitCategories || undefined);
  return (
    <div className="grid md:grid-cols-2 gap-x-16 gap-y-14" data-testid="price-list">
      {cats.map((cat, i) => (
        <Reveal key={cat} delay={(i % 2) * 0.1}>
          <h3 className="text-3xl font-medium mb-4 pb-3 border-b border-[#E5E0D8]">{cat}</h3>
          <ul>{groups[cat].map((s) => <PriceRow key={s.id} s={s} />)}</ul>
        </Reveal>
      ))}
    </div>
  );
};
